import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { loginAdminRequest, loginAdminSuccess, loginAdminFailure } from '../reducers/login';
import { xapiRequest } from '../reducers/xapi';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/login`;

function* loginAdminFunctionAxios() {
  const state = yield select(fullState => fullState);
 // const { Email: email, Password: password } = state.form.login.values;
  const response = yield call(() =>
    axios({
      method: 'post',
      url: API,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      data: {
        email:'support@cpslearn.co.za',
        password:'Password123#',
        type: 'client'
      },
    }),
  );

  return response;
}

function* workerLoginAdminSaga() {
  
  try {
   
    const response = yield call(loginAdminFunctionAxios);

    const responseFromLogin = response.data;
    
    if (response.status === 200) {
      
      yield put(loginAdminSuccess(responseFromLogin));
      yield put(xapiRequest({ xapiType: 'loginAdmin' }));
    }

    if (response.status === 205) {
      yield put(loginAdminFailure('Email does not exist'));
    }

    if (response.status === 206) {
      yield put(loginAdminFailure(responseFromLogin));
    }

    if (response.status === 500) {
      yield put(loginAdminFailure('internal server error'));
    }
  } catch (error) {
    yield put(loginAdminFailure(error));
  }
}

export function* watcherLoginAdminSaga() {
  yield takeLatest(loginAdminRequest().type, workerLoginAdminSaga);
}
